// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__tfIjZ","tableResponsive":"ClientDetail_tableResponsive__NoVBl"};